export const Url = "https://door.zlcsxy.com"; //线上
// export const Url = "http://192.168.1.24:8080"; // 调试
// 图片访问地址
export const imgUrl = "https://door.zlcsxy.com"
